<div class="modal-md transaction-result-modal">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-align-center"
      id="modal-label"
    >
      Order #{{ transactionGroup.totals.order_id }}
    </h1>
    <button
      type="button"
      (click)="onClose()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="fix-transaction--container mt-4">
      @if (isSuccessful) {
        <h1
          class="color-green uppercase line-separator--light-grey pb-4 text-align-center"
        >
          Your Card Was Successfully Charged
        </h1>
      }
      @if (!isSuccessful) {
        <h1
          class="color-red uppercase line-separator--light-grey pb-4 text-align-center"
        >
          Your Card Was Unable To Be Processed
        </h1>
      }

      <div class="transaction--info">
        <div class="d-flex mt-4">
          <label class="label">Transaction #</label>
          <span class="value">{{
            transactionGroup.totals.transaction_tag
          }}</span>
        </div>

        <div class="d-flex mt-4 pb-4 line-separator--light-grey">
          <label class="label">Payment Method</label>
          <span class="value">{{
            displayCreditCardLabel(transactionGroup.totals.last_four)
          }}</span>
        </div>

        <div class="d-flex flex-column align-content-center mt-4 text-center">
          @if (isSuccessful) {
            <span class="uppercase">Total Amount Charged</span>
          }
          @if (!isSuccessful) {
            <span class="uppercase color-red">Total Amount Attempted</span>
          }
          <span
            class="price value mt-2 fw-bold"
            [ngClass]="{ 'color-red': !isSuccessful }"
            >{{ transactionGroup.totals.amount | currency }}</span
          >
        </div>
      </div>

      @if (!isSuccessful) {
        <button
          class="btn btn-outline-primary d-block mx-auto"
          (click)="onStartOver()"
        >
          <span class="uppercase">Start Over</span>
        </button>
      }
    </div>
  </div>
</div>
